import { liteClient as algoliasearch } from 'algoliasearch/lite'

export const appId = process.env.REACT_APP_ALGOLIA_APP_ID || ''
export const appKey = process.env.REACT_APP_ALGOLIA_APP_KEY || ''

export const searchClient = algoliasearch(appId, appKey)
